module.exports = require("./ff-Latn-NE.d.ts");